import * as React from "react";

export default function Spacer() {
  const style = {
    marginTop: "10px",
  };
  return <div style={style}></div>;
}
